export default "__VITE_ASSET__432c81ea__"